import { useAppDispatch, useAppSelector } from "../hooks";
import { selectAuthReady } from "@onmo/auth";
import { Alert, ErrorHandling, Snackbar } from "@onmo/ui";
import { Outlet } from "react-router-dom";
import { hideSnackbar } from "../slices/alert";
import { useOnlineStatus } from "../hooks/useOnlineStatus";
import { CaLoading } from "../components/common/CaLoading/CaLoading";

export const RootLayout = () => {
  const dispatch = useAppDispatch();
  const alert = useAppSelector((state) => state.alert);
  const isOnline = useOnlineStatus();
  const authReady = useAppSelector(selectAuthReady);

  if (!isOnline) return <ErrorHandling type="network" />;
  if (!authReady) return <CaLoading />;

  return (
    <>
      {alert.isShowAlert && (
        <Alert message={alert.message} classify={alert.classify} />
      )}
      {alert.isShowSnackbar && (
        <Snackbar
          message={alert.message}
          onClose={() => dispatch(hideSnackbar())}
        />
      )}
      <Outlet />
    </>
  );
};
